import React from 'react';
import TablaTerritorios_CuerpoFilaTerritorio from './TablaTerritorios_CuerpoFilaTerritorio';
import { useViewContext } from '../../contexts/viewContext';
import { eleccion, level } from '../../resources/constantes.json';

const TablaTerritorios_Cuerpo = ({ data }) => {
  const viewContext = useViewContext();
  const isJal = viewContext.elec === eleccion.jal;
  const isMunicipio = viewContext.scope.l === level.municipio;
  const dataMap = isJal && isMunicipio
    ? data?.mapaganinfo
    : data?.mapagan

  return (
    <div>
      {dataMap?.map((partidoGanador, i) => {
        return <TablaTerritorios_CuerpoFilaTerritorio data={partidoGanador} key={i} />;
      })}
    </div>
  );
};

export default TablaTerritorios_Cuerpo;
